(function (root) {
  'use strict';

  if (root.__productCostingSurchargeLoaded) return;
  root.__productCostingSurchargeLoaded = true;

  var COSTING_SELECTOR = '[data-product-costing][data-product-surcharge]';
  var ADAPTER_VERSION = '2.0.0';
  var FINAL_PRICE_ROUNDING_CENTS = 100;
  var refreshTimer = null;
  var DEFAULT_INPUT_MAP = {
    widthMm: ['#po_number_field926202', '[name="po_larghezza"]', '[name="properties[Larghezza]"]'],
    heightMm: ['#po_number_field926203', '[name="po_altezza"]', '[name="properties[Altezza]"]'],
    thicknessMm: ['[name="po_spessore"]', '[name="properties[Spessore]"]'],
    drilling: ['[name="po_foratura"]', '[name="properties[Foratura]"]'],
    bevels: ['[name="po_smussi"]', '[name="properties[Smussi]"]'],
    edgePolishing: ['[name="po_lucidatura_bordi"]', '[name="properties[Lucidatura bordi]"]']
  };
  var DEFAULT_INPUTS = {
    thicknessMm: 5,
    materialId: 'plexiglas',
    backgroundColor: 'bianco',
    drilling: 'Nessuna',
    bevels: false,
    edgePolishing: true,
    artworkMinutes: 0
  };
  var FIELD_TEXT_MATCHES = {
    widthMm: ['larghezza', 'width'],
    heightMm: ['altezza', 'height'],
    thicknessMm: ['spessore', 'thickness']
  };

  function toInteger(value) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function toNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value !== 'string') return null;

    var normalized = value.replace(',', '.').replace(/[^\d.-]/g, '');
    var parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function roundUpCents(cents, stepCents) {
    var step = Math.max(1, toInteger(stepCents) || 1);
    return Math.ceil((Number(cents) || 0) / step) * step;
  }

  function normalizeString(value) {
    return String(value || '').trim();
  }

  function normalizeBoolean(value) {
    var normalized = normalizeString(value).toLowerCase();
    return ['1', 'true', 'si', 'sì', 'yes', 'on', 'ok'].indexOf(normalized) !== -1;
  }

  function getForm(context) {
    if (!context) return null;
    if (context.matches?.('form')) return context;
    return context.closest?.('form') || null;
  }

  function parseJsonAttribute(value, fallback) {
    if (!value) return fallback;

    try {
      var parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function normalizeSelectors(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string' && value.trim()) return [value];
    return [];
  }

  function getInputMap(element) {
    var configured = parseJsonAttribute(element.dataset.costingInputMap, {});
    var map = {};

    Object.keys(DEFAULT_INPUT_MAP).forEach(function (key) {
      map[key] = normalizeSelectors(configured[key]).concat(DEFAULT_INPUT_MAP[key]);
    });

    return map;
  }

  function queryField(form, selectors) {
    for (var index = 0; index < selectors.length; index += 1) {
      var selector = selectors[index];
      var field = null;

      try {
        field = form?.querySelector(selector) || root.document.querySelector(selector);
      } catch (error) {
        field = null;
      }

      if (field) return field;
    }

    return null;
  }

  function normalizeText(value) {
    return normalizeString(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function getFieldText(field) {
    if (!field) return '';

    var id = field.id || '';
    var directLabel = '';

    if (id) {
      try {
        directLabel = root.document.querySelector('label[for="' + CSS.escape(id) + '"]')?.textContent || '';
      } catch (error) {
        directLabel = '';
      }
    }

    var wrappingLabel = field.closest?.('label')?.textContent || '';
    var stackContainer = field.closest?.('.po-stack')?.textContent || '';
    var optionContainer = field.closest?.(
      '.po-stack, .po-option, .po-field, .option-selector, [class*="option"], [class*="Option"]'
    )?.textContent || '';

    return normalizeText([
      directLabel,
      wrappingLabel,
      stackContainer,
      optionContainer,
      field.getAttribute('name') || '',
      field.id || '',
      field.getAttribute('placeholder') || '',
      field.getAttribute('aria-label') || ''
    ].join(' '));
  }

  function textMatchesAny(text, matches) {
    return matches.some(function (match) {
      return text.indexOf(normalizeText(match)) !== -1;
    });
  }

  function queryFieldByText(form, matches) {
    var scopes = form ? [form, root.document] : [root.document];

    for (var scopeIndex = 0; scopeIndex < scopes.length; scopeIndex += 1) {
      var scope = scopes[scopeIndex];
      var fields = Array.from(scope.querySelectorAll('input, select, textarea')).filter(function (field) {
        if (field.disabled) return false;
        if (field.matches?.('input[type="radio"], input[type="checkbox"]') && !field.checked) return false;
        return textMatchesAny(getFieldText(field), matches);
      });

      var field = fields.filter(function (item) {
        return readFieldValue(item) !== null;
      })[0];

      if (field) {
        return field;
      }
    }

    return null;
  }

  function getFieldDescriptor(field) {
    if (!field) {
      return null;
    }

    return {
      tag: field.tagName ? field.tagName.toLowerCase() : '',
      type: field.getAttribute('type') || '',
      id: field.id || '',
      name: field.getAttribute('name') || '',
      value: readFieldValue(field),
      text: getFieldText(field)
    };
  }

  function resolveField(form, selectors, textMatches) {
    var configuredField = queryField(form, selectors);

    if (configuredField) {
      return {
        field: configuredField,
        source: 'selector'
      };
    }

    return {
      field: queryFieldByText(form, textMatches || []),
      source: 'text'
    };
  }

  function readFieldValue(field) {
    if (!field) return null;

    if (field.matches?.('input[type="checkbox"], input[type="radio"]')) {
      if (!field.checked) return null;
      return field.value || 'true';
    }

    if (field.matches?.('select')) {
      return field.value || field.selectedOptions?.[0]?.textContent || null;
    }

    return field.value || field.getAttribute('value') || field.textContent || null;
  }

  function readNumber(form, selectors, fallback, textMatches) {
    var resolved = resolveField(form, selectors, textMatches);
    var value = toNumber(readFieldValue(resolved.field));
    return value === null ? fallback : value;
  }

  function readChoice(form, selectors, fallback) {
    var field = queryField(form, selectors);
    var value = normalizeString(readFieldValue(field));
    return value || fallback;
  }

  function readBoolean(form, selectors, fallback) {
    var field = queryField(form, selectors);
    var value = readFieldValue(field);
    return value === null ? fallback : normalizeBoolean(value);
  }

  function buildInput(element, form) {
    var map = getInputMap(element);
    var modelId = normalizeString(element.dataset.costingModel) || 'targa_summa';
    var widthMm = readNumber(form, map.widthMm, null, FIELD_TEXT_MATCHES.widthMm);
    var heightMm = readNumber(form, map.heightMm, null, FIELD_TEXT_MATCHES.heightMm);

    if (!widthMm || !heightMm) {
      return null;
    }

    return {
      modelId: modelId,
      widthMm: widthMm,
      heightMm: heightMm,
      thicknessMm: readNumber(
        form,
        map.thicknessMm,
        DEFAULT_INPUTS.thicknessMm,
        FIELD_TEXT_MATCHES.thicknessMm
      ),
      materialId: DEFAULT_INPUTS.materialId,
      backgroundColor: DEFAULT_INPUTS.backgroundColor,
      // BSS owns the drilling choice and its surcharge; Preventivometro receives Foratura=No.
      drilling: DEFAULT_INPUTS.drilling,
      bevels: DEFAULT_INPUTS.bevels,
      edgePolishing: DEFAULT_INPUTS.edgePolishing,
      artworkMinutes: DEFAULT_INPUTS.artworkMinutes
    };
  }

  function debugElement(element) {
    var form = getForm(element);
    var api = root.ProductCosting;
    var map = getInputMap(element);
    var widthField = resolveField(form, map.widthMm, FIELD_TEXT_MATCHES.widthMm);
    var heightField = resolveField(form, map.heightMm, FIELD_TEXT_MATCHES.heightMm);
    var thicknessField = resolveField(form, map.thicknessMm, FIELD_TEXT_MATCHES.thicknessMm);
    var input = form ? buildInput(element, form) : null;
    var result = input && api?.calculate ? api.calculate(input, input.modelId) : null;

    return {
      elementFound: Boolean(element),
      formFound: Boolean(form),
      productId: element?.dataset.productId || '',
      modelId: element?.dataset.costingModel || '',
      configReady: Boolean(api?.ready),
      configStatus: api?.status || '',
      adapterVersion: ADAPTER_VERSION,
      calculatorAvailable: Boolean(api?.calculate),
      fields: {
        widthMm: {
          source: widthField.source,
          descriptor: getFieldDescriptor(widthField.field),
          number: toNumber(readFieldValue(widthField.field))
        },
        heightMm: {
          source: heightField.source,
          descriptor: getFieldDescriptor(heightField.field),
          number: toNumber(readFieldValue(heightField.field))
        },
        thicknessMm: {
          source: thicknessField.source,
          descriptor: getFieldDescriptor(thicknessField.field),
          number: toNumber(readFieldValue(thicknessField.field))
        }
      },
      input: input,
      result: result,
      displayedPriceCents: element?.dataset.costingDisplayedPriceCents || '',
      dataset: element ? Object.assign({}, element.dataset) : {}
    };
  }

  function debug(context) {
    var scope = context?.querySelectorAll ? context : root.document;
    var elements = Array.from(scope.querySelectorAll(COSTING_SELECTOR));

    if (context?.matches?.(COSTING_SELECTOR)) {
      elements.unshift(context);
    }

    return {
      count: elements.length,
      configReady: Boolean(root.ProductCosting?.ready),
      calculatorAvailable: Boolean(root.ProductCosting?.calculate),
      items: elements.map(debugElement)
    };
  }

  function setHiddenProperty(form, key, value) {
    if (!form) return;

    var fieldName = 'properties[' + key + ']';
    var field = Array.from(form.elements).find(function (element) {
      return element.name === fieldName;
    });

    if (!field) {
      field = root.document.createElement('input');
      field.type = 'hidden';
      field.name = fieldName;
      form.appendChild(field);
    }

    field.value = value;
  }

  function setPriceDataset(element, surchargeCents, expectedPriceCents) {
    var amount = Math.round(surchargeCents) / 100;

    element.dataset.surchargeCents = String(Math.round(surchargeCents));
    element.dataset.surchargeAmount = amount.toFixed(2);
    element.dataset.surchargeExpectedPrice = String(Math.round(expectedPriceCents));
  }

  function formatMoney(cents) {
    var amount = Math.round(Number(cents) || 0) / 100;
    var formatted = amount.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var format = root.theme?.money_format || '€{{amount_with_comma_separator}}';

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount\s*\}\}/g, amount.toFixed(2));
  }

  function getProductContainer(form) {
    return (
      form?.closest?.('.product-form') ||
      form?.closest?.('[data-section-type="main-product"]') ||
      form?.closest?.('[data-section-type="featured-product"]') ||
      root.document
    );
  }

  function updateDisplayedPrice(form, element, finalPriceCents, surchargeCents) {
    var container = getProductContainer(form);
    var priceElement = container.querySelector('[data-surcharge-price]');

    if (!priceElement) {
      return null;
    }

    priceElement.textContent = formatMoney(finalPriceCents);
    priceElement.dataset.surchargeCents = String(Math.round(surchargeCents));
    priceElement.dataset.surchargeRenderedCents = String(Math.round(finalPriceCents));
    element.dataset.costingDisplayedPriceCents = String(Math.round(finalPriceCents));

    return priceElement;
  }

  function writeBssPayload(form, element, result) {
    var basePriceCents = toInteger(element.dataset.costingBasePriceCents);
    var rawFinalPriceCents = Math.round((result.totals?.totalVatIncluded || 0) * 100);
    var roundedSalePriceCents = Math.round((result.totals?.roundedSalePrice || 0) * 100);
    var finalPriceCents = roundedSalePriceCents || roundUpCents(rawFinalPriceCents, FINAL_PRICE_ROUNDING_CENTS);
    var surchargeCents = Math.max(0, finalPriceCents - basePriceCents);
    var expectedPriceCents = basePriceCents + surchargeCents;
    var surchargeAmount = Math.round(surchargeCents) / 100;

    setPriceDataset(element, surchargeCents, expectedPriceCents);
    updateDisplayedPrice(form, element, finalPriceCents, surchargeCents);
    setHiddenProperty(form, '_bssPrice', JSON.stringify({ extra: surchargeAmount }));
    setHiddenProperty(form, '_bssVariants', '{}');
    setHiddenProperty(form, '_bssCustomAttributes', '{}');

    element.dataset.costingStatus = result.status;
    element.dataset.costingRawTotalCents = String(rawFinalPriceCents);
    element.dataset.costingTotalCents = String(finalPriceCents);
    element.dataset.costingRoundingStepCents = String(FINAL_PRICE_ROUNDING_CENTS);
    element.dataset.costingAdapterVersion = ADAPTER_VERSION;

    return result;
  }

  function refreshElement(element) {
    var form = getForm(element);
    var api = root.ProductCosting;

    if (!form || !api?.calculate) {
      return null;
    }

    var input = buildInput(element, form);
    if (!input) {
      element.dataset.costingStatus = 'INPUT_INCOMPLETO';
      return null;
    }

    var result = api.calculate(input, input.modelId);
    if (!result || result.status !== 'OK') {
      element.dataset.costingStatus = result?.status || 'CALCOLO_NON_DISPONIBILE';
      return result || null;
    }

    return writeBssPayload(form, element, result);
  }

  function refreshAll(context) {
    var scope = context?.querySelectorAll ? context : root.document;
    var elements = Array.from(scope.querySelectorAll(COSTING_SELECTOR));

    if (context?.matches?.(COSTING_SELECTOR)) {
      elements.unshift(context);
    }

    return elements.map(refreshElement).filter(Boolean);
  }

  function scheduleRefresh(context, delay) {
    root.clearTimeout(refreshTimer);
    refreshTimer = root.setTimeout(function () {
      refreshAll(context || root.document);
    }, delay || 50);
  }

  function scheduleRefreshSeries(context, delays) {
    (delays || [50, 250, 800]).forEach(function (delay) {
      root.setTimeout(function () {
        refreshAll(context || root.document);
      }, delay);
    });
  }

  function scheduleInitialRefreshes() {
    [0, 250, 1000, 2500, 5000].forEach(function (delay) {
      root.setTimeout(function () {
        refreshAll(root.document);
      }, delay);
    });
  }

  function getRefreshContext(target) {
    var form = getForm(target);

    if (form?.querySelector(COSTING_SELECTOR)) {
      return form;
    }

    if (
      root.document.querySelector(COSTING_SELECTOR) &&
      target?.closest?.('input, select, textarea, label, button, .po-stack, .po-option, .po-field')
    ) {
      return root.document;
    }

    return null;
  }

  function isTextEntryField(target) {
    if (!target?.matches) return false;

    return target.matches(
      'textarea, select, input:not([type]), input[type="text"], input[type="number"], input[type="email"], input[type="tel"], input[type="search"], input[type="url"]'
    );
  }

  function isDelayedOptionTarget(target) {
    if (!target?.closest) return false;
    if (isTextEntryField(target)) return false;

    return Boolean(
      target.closest(
        'input[type="radio"], input[type="checkbox"], label, button, .po-option, .po-option__value, .po-option--button-wrapper, .po-stack'
      )
    );
  }

  root.document.addEventListener(
    'input',
    function (event) {
      var context = getRefreshContext(event.target);
      if (context) {
        scheduleRefresh(context);
      }
    },
    true
  );

  root.document.addEventListener(
    'change',
    function (event) {
      var context = getRefreshContext(event.target);
      if (context) {
        scheduleRefreshSeries(context);
      }
    },
    true
  );

  root.document.addEventListener(
    'click',
    function (event) {
      if (!isDelayedOptionTarget(event.target)) return;

      var context = getRefreshContext(event.target);
      if (context) {
        scheduleRefreshSeries(context, [180, 500, 1200]);
      }
    },
    true
  );

  root.document.addEventListener(
    'pointerup',
    function (event) {
      if (!isDelayedOptionTarget(event.target)) return;

      var context = getRefreshContext(event.target);
      if (context) {
        scheduleRefreshSeries(context, [180, 500, 1200]);
      }
    },
    true
  );

  root.document.addEventListener(
    'submit',
    function (event) {
      var form = getForm(event.target);
      if (form?.querySelector(COSTING_SELECTOR)) {
        refreshAll(form);
      }
    },
    true
  );

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', function () {
      scheduleInitialRefreshes();
    });
  } else {
    scheduleInitialRefreshes();
  }

  root.addEventListener('load', function () {
    scheduleInitialRefreshes();
  });

  if (root.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = mutations.some(function (mutation) {
        if (mutation.type === 'attributes') {
          var target = mutation.target;
          if (!target || target.nodeType !== 1) return false;
          if (isTextEntryField(target)) return false;
          return Boolean(getRefreshContext(target));
        }

        return Array.from(mutation.addedNodes || []).some(function (node) {
          if (!node || node.nodeType !== 1) return false;
          return node.matches?.(COSTING_SELECTOR + ', input, select, textarea, form') ||
            Boolean(node.querySelector?.(COSTING_SELECTOR + ', input, select, textarea, form'));
        });
      });

      if (shouldRefresh && root.document.querySelector(COSTING_SELECTOR)) {
        scheduleRefresh(root.document, 100);
      }
    });

    observer.observe(root.document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'class', 'value', 'aria-checked', 'selected']
    });
  }

  root.ProductCostingSurcharge = {
    refresh: refreshAll,
    debug: debug
  };
})(typeof window !== 'undefined' ? window : this);
